import React from "react";
import { Link, useLocation, useMatch, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import henceforthApi from "../utils/henceforthApi";
// import placeholder from "../assets/images/profile_placeholder.jpg"
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import moment from "moment";
import PaginationLayout from "../components/PaginationLayout";
import { getUserProfileImage } from "../utils/constant_value";


function Post({ userDetailsPost, getUserPosts }) {
  console.log("checkuser", userDetailsPost, "hhhh", getUserPosts)

  const match = useMatch("/user/:id/:type");
  const navigate = useNavigate()
  //Remove
  const [showRemove, setShowRemove] = useState(false);
  const handleConfirm = (id) => {
    setShowRemove(id);
  }
  // const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0)
  const [data, setData] = useState()
  // const [getUserPosts, setGetUserPosts] = useState([]);
  // const userDetailsPost = async (_id) => {
  //   setLoading(true);
  //   let apiRes = await henceforthApi.User.getUserDetailsPosts(
  //     id,
  //     Number(page),
  //     Number(limit)
  //   );
  //   console.log(apiRes, "apiRes")
  //   setLoading(false);
  //   setData(apiRes?.data)
  //   setTotalCount(apiRes?.data.length)
  //   // setGetUserPosts(apiRes);
  // };
  const handleRemove = async (id) => {
    console.log(id)
    try {
      await henceforthApi?.Posts?.delete(id);
      setShowRemove(false);
      userDetailsPost();
    } catch (Error) {
    }
    setShowRemove(false)
  };

  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState([])
  const initialiseLightBox = (data) => {
    setPhotoIndex(0)
    setIsOpen(true)
    setLightboxImages(data)
  }

  //Modal
  const [like, setLike] = useState(false);
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [comment, setComment] = useState(false);
  const [Tag, setTags] = useState(false);
  const [Coin, setCoin] = useState(false);
  const handleCloseTags = () => setTags(false);
  const handleCloseCoin = () => setCoin(false);

  //Tags
  const [getTags, setGetTags] = useState([]);
  const handleTags = async (Tag) => {
    setTags(true);
    try {
      const TagsResponse = await henceforthApi?.Posts?.tags(Tag);
      setGetTags(TagsResponse);
    } catch (error) {
    }
  };

  //Coins
  const [getCoins, setGetCoins] = useState([]);
  const [totalCoins, setGetTotalCoins] = useState({});

  const handleCoin = async (Coin) => {
    setCoin(true);
    try {
      const CoinsResponse = await henceforthApi?.Posts?.coins(Coin);
      setGetCoins(CoinsResponse);
      setGetTotalCoins(CoinsResponse);
    } catch (error) {
    }
  };
  const limit = 9
  //Like
  const [getLike, setGetLike] = useState([]);
  const HandleLike = async (like) => {
    setLike(true);
    try {
      const likeResponse = await henceforthApi?.Posts?.like(like);
      setGetLike(likeResponse);
    } catch (error) {
    }
  };
  const onChangePagination = (page) => {
    // const newParam = new URLSearchParams(location.search);
    // navigate(`/user/${newVal}`);
    setPage(page)
  };
  //Comment
  const [getComment, setGetComment] = useState([]);
  const HandleComment = async (LC) => {
    setComment(true);
    try {
      const CommentResponse = await henceforthApi?.Posts?.Comment(LC);
      setGetComment(CommentResponse);
    } catch (error) {
    }
  };


  const [showImage, setShowImage] = useState(false);
  const handleShow = (id) => {
    setShowImage(id)
  }


  // useEffect(() => {
  //   // getUserPosts();
  //   userDetailsPost()
  // }, [match?.params?.id, page]);

  return (
    <div>

      <div className="row">
        <div>
          {isOpen && <Lightbox
            mainSrc={`${henceforthApi?.API_FILE_ROOT_ORIGINAL}${lightboxImages[photoIndex].media_url}`}
            nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
            prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % lightboxImages.length)
            }
          />}
        </div>
        {getUserPosts?.data?.length ? getUserPosts.data.map((item, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card mb-4 box-shadow border-0 shadow h-100">
              <Link to="">
                <div className="explore-img">
                  <Carousel interval={null}>
                    {item?.post_medias?.length ? (
                      item.post_medias.map((res, i) => (
                        <Carousel.Item key={i}>
                          {(res?.media_type === "VIDEO/MP4" || res?.media_type === "VIDEO") ? (
                            <video
                              id="videos"
                              className="video-bg"
                              src={`${henceforthApi?.API_FILE_ROOT_ORIGINAL}${res?.media_url}`}
                              autoPlay
                            />
                          ) : (
                            <img
                              className="d-block w-100"
                              src={`${henceforthApi?.API_FILE_ROOT_ORIGINAL}${res?.media_url}`}
                              alt="PostImage"
                              onClick={() => initialiseLightBox(item?.post_medias)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </Carousel.Item>
                      ))
                    ) : (
                      <img
                        className="d-block w-100"
                        src={profile_placeholder}
                        alt="PostImage"
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </Carousel>
                </div>
              </Link>

              <div className="card-body">
                {/* Username + Privacy */}
                <div className="username-box my-1 d-flex justify-content-between align-items-center">
                  <div className="d-flex gap-1 ProfileImagePRS-box">
                    <img
                      className="ProfileImagePRS"
                      src={getUserProfileImage(item?.profile_pic)}
                      alt=""
                    />
                    <p className="fw-bolder m-0" style={{ fontSize: "14px" }}>
                      {item?.name}
                    </p>
                  </div>
                  <div>
                    <label className="PublicPrivate">
                      <i
                        className={item?.is_private === false ? `fas fa-globe-africa` : `fas fa-lock`}
                        style={{ marginRight: "3px" }}
                      ></i>
                      {item?.is_private === false ? "Public" : "Private"}
                    </label>
                  </div>
                </div>

                {/* Description + Status */}
                <div className="row">
                  <div className="col-6">
                    <div className="desc-box" style={{ minHeight: "45px" }}>
                      <p className="m-0" style={{ fontSize: "14px" }}>
                        <b>Description:</b> <span>{item?.discription}</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-6 text-end">
                    <label className={item.status === "Active" ? "custom-status" : "custom-status-deactivate"}>
                      {item.status}
                    </label>
                  </div>
                </div>

                {/* Tags + Coins */}
                <div className="both-added my-3">
                  <div>
                    <div className="fw-bolder">
                      <h6 onClick={() => handleTags(item?._id)} style={{ cursor: "pointer", fontSize: "14px" }}>
                        Tags: <span style={{ fontWeight: "bold" }}>{item?.tags_count ?? 0}</span>
                      </h6>
                      {/* <h6 onClick={() => handleCoin(item?._id)} style={{ cursor: "pointer", fontSize: "14px" }}>
                        Coin:
                        <span style={{ fontWeight: "bold", marginLeft: "3px" }}>
                          <i
                            style={{ marginRight: "2px", fontSize: "17px" }}
                            className="fas fa-usd-circle"
                          ></i>
                          {item?.coins_count}
                        </span>
                      </h6> */}
                    </div>
                  </div>
                  <div className="brown-text text-wrap">
                    <div className="fw-bolder text-end" style={{ cursor: "pointer" }}>
                      <h6 style={{ fontSize: "14px" }} onClick={() => HandleComment(item?._id)}>
                        Comments: <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{item?.comments_count}</span>
                      </h6>
                      <h6 style={{ fontSize: "14px" }} onClick={() => HandleLike(item?._id)}>
                        Likes: <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{item?.likes_count}</span>
                      </h6>
                    </div>
                  </div>
                </div>

                <hr />

                {/* Created At + Birthday */}
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="bown-num">
                      <p className="m-0">
                        <small>
                          {moment(Number(item?.created_at)).format("DD MMM YYYY, h:mm a")}
                        </small>
                      </p>
                      <p className="m-0">
                        <small>
                          Birthday: {moment(Number(getUserPosts?.user?.birthday)).format("DD MMM YYYY")}
                        </small>
                      </p>
                    </div>
                  </div>

                  {item?.is_removed !== true && (
                    <div className="col-md-6">
                      <Link to={`/media/${item._id}/like`}>
                        <button
                          onClick={() => handleConfirm(item._id)}
                          style={{ float: "right" }}
                          className="btn mt-2 btn-outline-dark"
                        >
                          Details
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )) : (
          <div className="text-center">No Posts Found</div>
        )}

      </div >

      <div>
        <Modal
          show={showRemove}
          onHide={() => setShowRemove(false)}
          backdrop="static"
          keyboard={false}
          centered
          className="confirm-box-modal"
        >
          <Modal.Header>
            <Modal.Title>
              Remove
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="my-3 text-center">
              Do you want to Remove?
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setShowRemove(false)} className="px-6 confirm-btn">
              No
            </Button>
            <Button onClick={() => handleRemove(showRemove)} className="px-6 confirm-btn">
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        {/* Modals */}
        <Modal show={like} onHide={() => setLike(false)} centered scrollable>
          <Modal.Header closeButton>
            <Modal.Title>
              Likes
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {getLike?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Likes</div> : getLike?.data?.map((item, index) => (
              <>
                <div
                  className="modal-wrapper d-flex align-items-center  mx-2"
                  key={index}
                >
                  <img
                    src={getUserProfileImage(item?.profile_pic)}
                    alt="ProfileImage"
                    class="modal-profile me-2"
                  />
                  <Link
                    to={`/user/${item?.user_id}/1/1?type=posts`}
                    className="Details_of_User"
                  >
                    <p className="mb-0 profile-name">{item?.name}</p>
                  </Link>
                </div>
                < hr />
              </>
            ))}
          </Modal.Body>
        </Modal >
        {/* Comment */}
        <Modal show={comment} onHide={() => setComment(false)} centered scrollable>
          <Modal.Header closeButton>
            <Modal.Title>
              Comment
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {getComment?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Comments</div> : getComment?.data?.map((item, index) => (
              <>
                <div
                  className="image-name-box d-flex gap-2 align-items-start w-100"
                  key={index}
                >
                  <div className="image-box">
                    <img
                      src={getUserProfileImage(item?.profile_pic)}
                      alt="ProfileImage"
                      class="modal-profile align-items-start"
                    />
                  </div>

                  <div className="name-box w-100">
                    <div className="d-flex align-items-center justify-content-between ">
                      <div>
                        <Link
                          to={`/user/${item?.user_id}/1/1?type=posts`}
                          className="Details_of_User"
                        >
                          <p className="mb-0 profile-name">
                            {item.name}
                          </p>
                        </Link>
                      </div>
                      <div className="">
                        <p
                          className="m-0"
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {moment(Number(item?.created_at)).format(
                            "DD MMM YYYY, h:mm a"
                          )}
                        </p>
                      </div>
                    </div>
                    <p
                      className="m-0"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {item?.comments}
                    </p>
                  </div>
                </div>
                <hr />
              </>
            ))}
          </Modal.Body>
        </Modal >
      </div >
      <div>
        <Modal show={Tag} onHide={handleCloseTags} centered
          scrollable

        >
          <Modal.Header closeButton>
            <Modal.Title>
              <Link
                to=""
                style={{
                  textDecoration: "none",
                  color: "#000000",
                  cursor: "auto",
                }}
              >
                Tags
              </Link>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {getTags?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Tags</div> : getTags?.tagged_users?.map((item, index) => (
              <>
                <div>
                  <div className="modal-wrapper d-flex align-items-center  mx-2" key={index}>
                    <img
                      src={getUserProfileImage(item?.profile_pic)}
                      alt="ProfileImage"
                      class="modal-profile me-2"
                    />
                    <Link
                      to={`/user/${item?.user_id}/1/1?type=posts`}
                      className="Details_of_User"
                    >
                      <p className="mb-0 profile-name">
                        {item?.full_name}
                      </p>
                    </Link>
                  </div>
                </div>
                <hr />
              </>
            ))}
          </Modal.Body>
        </Modal>
      </div>
      <div>
        <Modal show={Coin} onHide={handleCloseCoin} centered
          scrollable

        >
          <Modal.Header closeButton>
            <Modal.Title>
              <Link
                to=""
                style={{
                  textDecoration: "none",
                  color: "#000000",
                  cursor: "auto",
                }}
              >
                Coins
              </Link>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {getCoins?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Coins</div> : getCoins?.data?.map((item, index) => (
                <div className="col-sm-12 ">
                  <div
                    className="image-name-box d-flex gap-2 align-items-right justify-content-between px-3"
                    key={index}
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <div className="image-box">
                        <img
                          src={getUserProfileImage(item?.users?.profile_pic)}
                          alt="ProfileImage"
                          class="modal-profile"
                        />
                      </div>

                      <div className="name-box">
                        <Link
                          to={`/user/${item?.users?._id}/1/1?type=posts`}
                          className="Details_of_User"
                        >
                          <p className="mb-0 profile-name">
                            {item?.users?.full_name}
                          </p>
                        </Link>
                        <div>
                          <p
                            className="m-0"
                            style={{
                              fontSize: "10px",
                            }}
                          >
                            {moment(
                              Number(item?.users?.created_at)
                            ).format("DD MMM YYYY, h:mm a")}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="image-name-box">
                      <p>
                        <i
                          style={{ marginRight: "2px" }}
                          class="fas fa-usd-circle"
                        ></i>
                        {item?.coins}
                      </p>
                    </div>
                  </div>
                  <hr />
                </div>
              ))}
              {totalCoins?.coins_count == 0 ? " " :
                <>
                  <div className="col-sm-8 d-flex gap-2 align-items-center">
                    <h6 style={{ fontWeight: "bold" }} className="ps-3">
                      Total Received :
                    </h6>
                  </div>
                  <div className="col-sm-4">
                    <dt className="text-end pe-3">
                      <i
                        style={{ marginRight: "2px" }}
                        class="fas fa-usd-circle"
                      ></i>
                      {totalCoins?.coins_count}
                    </dt>
                  </div>
                </>
              }
            </div>
          </Modal.Body>
        </Modal>
        {/* <PaginationLayout
              count={totalCount}
              data={data}
              page={Number(page)}
              limit={Number(limit)}
              loading={loading}
              onPageChange={(val) => onChangePagination(val)}
            /> */}
      </div>
    </div >
  );
}

export default Post;
